<mat-icon *ngIf="type == IconType.Mat" [ngClass]="matClass" [inline]="true">{{icon[0]}}</mat-icon>
<fa-icon *ngIf="type == IconType.FA" [ngClass]="faClass" [icon]="icon" [rotate]="faRotate"></fa-icon>
